import { render, staticRenderFns } from "./ModuleTokens.vue?vue&type=template&id=30c99fae"
import script from "./ModuleTokens.vue?vue&type=script&lang=js"
export * from "./ModuleTokens.vue?vue&type=script&lang=js"
import style0 from "./ModuleTokens.vue?vue&type=style&index=0&id=30c99fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports